import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "../../lib/api";
import { tr } from "./parts";

export const MagazineTeaser = ({ lang }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    const go = () => api.get("/public/magazine", { params: { lang } }).then((r) => setD(r.data)).catch(() => setD(null));
    if (document.readyState === "complete") go(); else window.addEventListener("load", go, { once: true });
    return () => window.removeEventListener("load", go);
  }, [lang]);
  if (!d?.articles?.length) return null;
  return (
    <section className="px-4 sm:px-10 pb-14 sm:pb-24 bg-[#F7F3EA]" data-testid="home-magazine">
      <Link to={`/${lang}/magazine`} className="flex items-center justify-between gap-4 rounded-3xl bg-[#0B2A4A] text-white p-6 sm:p-10 hover:bg-[#123a63] transition-colors" data-testid="home-magazine-link">
        <div>
          <p className="text-[#E9DCC3] text-[11px] tracking-[0.35em]">AMALFI VIBES MAGAZINE</p>
          <h2 className="pp-serif text-3xl sm:text-4xl mt-2">{tr("explore", lang)}</h2>
          <p className="text-white/75 text-sm mt-2">{tr("sub", lang)}</p>
        </div>
        <ArrowRight className="shrink-0" />
      </Link>
    </section>
  );
};
